import { createFileRoute } from '@tanstack/react-router';
import { AdminAuditPage } from '../../features/admin-shell';

export const Route = createFileRoute('/admin/audit')({ component: AdminAuditPage });
